import React, {useState, useEffect} from 'react';
import styles from "./ContestBanner.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {fetchContests} from "../contestSlice";
const ContestBanner = () => {
    const token = useSelector(state => state.loginSlice.token);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const contests = useSelector(state => state.contestSlice.contests)
    const getNavigatePath = (contest) => {
        if (contest?.results_active) {
            return '/winners';
        } else if (contest?.registration_active) {
            return `/contest/${contest.id}`;
        } else if (contest?.voting_active) {
            return '/voteList';
        }
        return '/';
    };

    const getButtonText = (contest) => {
        if (contest?.results_active) {
            return 'Результаты';
        } else if (contest?.registration_active) {
            return 'Регистрация';
        }
        return 'Голосовать';
    };






    useEffect(() => {
        if (token) {
            dispatch(fetchContests({token}));
        }else {
            console.log("No Token")
        }
    }, [token, dispatch]);



    function formatDate(isoString) {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    return (
        <>
            {contests && (
                <>
                    {contests.map(contest =>
                        contest.active &&
                        <div>
                            <div className={styles.contestContainer}>
                                <div className={styles.contestDescription}>
                                    <h1 className={styles.contestHeading}>Конкурс «{contest?.name}»</h1>
                                    <div>
                                        <p className={styles.contestText}>{'Срок проведения конкурса'}</p>
                                        <p className={styles.contestDate}>
                                            с {formatDate(contest?.starts_at)}<br/>по {formatDate(contest?.ends_at)}
                                        </p>
                                        <button
                                            onClick={() => {
                                                const path = getNavigatePath(contest);
                                                localStorage.setItem('contestID', contest.id);
                                                navigate(path);
                                            }}
                                            className={styles.contestBtn}
                                        >
                                            {getButtonText(contest)}
                                        </button>
                                    </div>
                                </div>
                                <div className={styles.imgContainer}>
                                    <img src={contest?.image?.image} alt="Конкурс" className={styles.contestImg}/>
                                </div>
                            </div>
                            {contest?.voting_active &&
                                <div onClick={() => {localStorage.setItem('contestID', contest.id); navigate('/voteList')}} className={styles.showAllVideosBtn}>
                                    <span>Посмотреть все видео конкурса</span>
                                </div>
                            }
                        </div>
                    )}

                </>
            )}
        </>
    );
}

export {ContestBanner};
